import { render, staticRenderFns } from "./send-redpack-dialog.vue?vue&type=template&id=80a8b51c&scoped=true"
import script from "./send-redpack-dialog.vue?vue&type=script&lang=js"
export * from "./send-redpack-dialog.vue?vue&type=script&lang=js"
import style0 from "./send-redpack-dialog.vue?vue&type=style&index=0&id=80a8b51c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a8b51c",
  null
  
)

export default component.exports